import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { TermsDto, TermsService } from '@api-client';
import { TermType } from '@common';
import { LepiIcon, ModalService } from '@lepisode-ui/components';
import { DecodeHtmlPipe } from 'apps/client/src/app/pipes/decorde-html.pipe';
import { QuillViewComponent } from 'ngx-quill';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-terms-modal',
  standalone: true,
  imports: [CommonModule, LepiIcon, QuillViewComponent, DecodeHtmlPipe],
  templateUrl: './terms-modal.modal.html',
  styleUrl: './terms-modal.modal.scss',
})
export default class TermsModalModal implements OnInit {
  modalService = inject(ModalService);
  terms = signal<TermsDto | null>(null);
  @Input() type?: keyof typeof TermType;
  termType = TermType;
  refresh$ = new BehaviorSubject<void>(undefined);
  termsService = inject(TermsService);

  handleDismiss() {
    this.modalService.dismiss();
  }

  label() {
    const type = this.type as keyof typeof TermType;
    return TermType[type];
  }

  ngOnInit(): void {
    this.termsService
      .termsControllerFindFirst({
        type: this.type as keyof typeof TermType,
      })
      .subscribe({
        next: (terms: TermsDto) => {
          this.terms.set(terms);
        },
      });
  }
}
